/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum RoleCode {
    SUPER_ADMIN = 'super_admin',
    COMPANY_ADMIN = 'company_admin',
    COMPANY_USER = 'company_user',
    SURVEY_UPLOAD_MANAGER = 'survey_upload_manager',
    TENANT_ADMIN = 'tenant_admin',
}
